// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { AppCleanup } from '../../../shared/models';

// Models
import { UserModel } from '../../../shared/models/user-model.model';

@Injectable({
	providedIn: 'root',
})
export class UserService extends AppCleanup {
	private userUrl;

	constructor(private http: HttpClient) {
		super();
		this.userUrl = `${this.apiUrl}api/user`;
	}

	getUsers() {
		return this.http.get<UserModel[]>(this.userUrl);
	}

	getUser(id: number) {
		return this.http.get<UserModel>(`${this.userUrl}/${id}`);
	}

	getUserPrimaryRole(roles: number[]) {
		let primaryRole: string = roles.includes(6) ? 'Tenant Admin' : roles.includes(3) ? 'Super Admin' : roles.includes(2) ? 'Admin' : roles.includes(1) ? 'Member' : roles.includes(6) ? 'Pending User' : '--';
		return primaryRole;
	}

	getPendingUsersForUser() {
		return this.http.get<number>(`${this.userUrl}/pending`);
	}

	createUpdateUser(user: UserModel) {
		return this.http.put<UserModel>(this.userUrl, user);
	}

	saveUserSimple(user: UserModel) {
		return this.http.put<UserModel>(this.userUrl + '/saveuserdetailsimple', user);
	}

	deleteUser(id: number) {
		return this.http.delete<UserModel>(`${this.userUrl}/${id}`);
	}
}
